import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbOffcanvas, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { css } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CompositionService } from '../../../../../core/services/composition.service';
import { NoteService } from '../../../../../core/services/note.service';
import { PeriodService } from '../../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { RoomService } from '../../../../../core/services/room.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { FileService } from '../../../../../core/utils/file-service';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../../admin/layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-note-create',
    templateUrl: './note-create.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./note-create.component.css']
})
export class NoteCreateComponent {

  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  notes:any[] =[]
  periods:any[] =[]
  compositions:any[] =[]
  courses:any[] =[]
  paccs:any[] =[]
  selected_data:any;
  modalOption:any; 
  paccId:any; 
  periodId:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-note-create"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  compositionData:any
  compositionId:any
  composition_id:any
  rooms:any[] =[]

  @ViewChild('addContent') addContent:TemplateRef<any> | undefined


  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  saveMode=false;

  constructor(
    private spinnerService:NgxSpinnerService,
    private noteService:NoteService,
    private router:Router,
    private route:ActivatedRoute,
    private compService:CompositionService,
    private periodService:PeriodService,
    private sacService:StudentAyClassroomService,
    private pacService:ProfessorAcademicClassroomService,
    private toastrService:ToastrService,
    private roomService:RoomService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngAfterViewInit(): void {
    if (this.saveMode) {
      this.toastrService.info('Veuillez patienter, nous préparons votre espace.','Enregistrer un devoir')
      setTimeout(() => {
        this.modalService.open(this.addContent)

      }, 2000);
    }
  }
  ngOnInit(): void {
    this.saveMode=this.route.snapshot.paramMap.get('save')?true:false;
    console.log(this.route.snapshot.paramMap.get('save'),this.saveMode,this.route.snapshot.paramMap)
    if(!this.saveMode){
    this.compositionId=this.route.snapshot.paramMap.get('id')
    this.compositionId==undefined?this.init():this.loadNotes()
    }

    this.init()
    this.getActions()
  }

  init(){
    this.getProfessorAcademicClassrooms ()
    this.getPeriods()
    this.getProfessorAcademicClassroomCourses()
    this.getRooms()


  }
  loadNotes(){
    this.data=[]
    this.spinnerService.show()
    this.compService.get(this.compositionId).subscribe((res:any)=>{
      res.data.notes.forEach((element:any) => {
        this.data.push({
          id:element.id,
          code:element.sac?.student?.code,
          photo:element.sac?.photo,
          lastname:element.sac?.student?.lastname,
          firstname:element.sac?.student?.firstname,
          name:element.sac?.student?.firstname+" "+element.sac?.student?.lastname,
          value:element?.value,
          isSetted:element?.is_setted,
          motif:element?.motif,
          motif_file:element?.motif_file,
          appreciation:element?.appreciation,
          hasFile:element?.motif_file!=null?true:false
        })
      });
      this.spinnerService.hide()

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des notes",err)

    })

  }

  getRooms(){
    this.roomService.getByState(1).subscribe((res:any)=>{
      this.rooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des devoirs de maison",err)
    })
  }

  getPeriods(){
    this.periodService.getByState(1).subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des notes",err)
    })
  }

  loadCourses(event:any){
    console.log(event)
    let paccId=this.saveMode? event?.id:event.target.value
    let pacc=this.paccs.find((el:any)=>el.id==paccId)
    this.courses=pacc.courses
    this.getStudentAcademicClassroomList(pacc?.classroom?.id)

  }

  open(i:any){
    this.pdfSrc=this.data[i].motif_file
    this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

  }
 

  getStudentAcademicClassroomList(classroomId:any){
    this.data=[]
    this.spinnerService.show()
    this.sacService.getAll(classroomId).subscribe((res:any)=>{
      res.data.forEach((element:any) => {
        this.data.push({
          id:element.student?.current_ay_classroom?.id,
          code:element.student?.code,
          photo:element.photo,
          lastname:element?.student?.lastname,
          firstname:element?.student?.firstname,
          name:element.student?.lastname+" "+element.student?.firstname,
          value:0,
          isSetted:1,
          motif:"",
          motif_file:"",
          appreciation:"",
          hasFile:false
        })
      });
      this.spinnerService.hide()

     // this.modalService.dismissAll()
    },
    (err:any)=>{
      this.spinnerService.hide()

AppErrorShow.showError("Gestion des notes",err)
    })
  }
  getProfessorAcademicClassrooms(){
    this.pacService.getProfessorAcademicClassrooms().subscribe((res:any)=>{
      this.classrooms=res.data
    //  this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des notes",err)
    })
  }
  getProfessorAcademicClassroomCourses(){
    this.pacService.getProfessorAcademicClassroomsCourses().subscribe((res:any)=>{
      this.paccs=res.data
      //this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des notes",err)
    })
  }
  loadCompositions1(event:any){
    if (!this.saveMode) {
      this.paccId=this.courses.find((el:any)=>el.id==event.target.value).pivot?.id

      if (this.paccId != undefined && this.periodId!=undefined) {
        this.compService.getByCoursePeriod(this.paccId,this.periodId,1).subscribe((res:any)=>{
          this.compositions=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Gestion des notes",err)
  
        })
      } 
    }

   
  }
  loadCompositions2(event:any){
    if (!this.saveMode) {
      this.periodId=event.target.value

      if (this.paccId != undefined && this.periodId!=undefined) {
        this.compService.getByCoursePeriod(this.paccId,this.periodId,1).subscribe((res:any)=>{
          this.compositions=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Gestion des notes",err)
  
        })
      } 
    }

   
  }


  resetNote(event:any, i:any){
      if(event.target.value=="0")this.data[i].value=0
      this.data[i].isSetted=event.target.value=="0"?0:1
  }


  async upload(ev:any, i:any){
    if (ev.target.files.length!=0) {
      this.data[i].motif_file=await FileService.fromArrayBufferToBase64(await FileService.readFileAsync(ev.target.files[0]))
      this.data[i].hasFile=true
    }
  }


  loadlist(e:any){
    this.getStudentAcademicClassroomList(e.target.value)
  }

  remove(i:any){
    this.data[i].motif_file=""
    this.data[i].hasFile=false  
  }


  store(){

    if(this.composition_id==undefined && !this.saveMode){
      this.toastrService.warning('Le choix de l\'évaluation est obligatoire')
      return;
    } 
    this.loading=true
    this.spinnerService.show()
    this.noteService.store({
      composition_id:this.composition_id,
      notes:this.data,
      saveMode:this.saveMode,
      composition:this.compositionData
    }).subscribe((res:any)=>{
      this.loading=false
      this.spinnerService.hide()

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.router.navigate([`/professor-module/note-index`],{ queryParams: {compositionId: res.data.compositionId}})
        

    },
    (err:any)=>{
      this.loading=false
      this.spinnerService.hide()

      console.log(err)
        AppErrorShow.showError("Gestion des notes",err)

    })
  }
  update(){
    this.loading=true

    this.spinnerService.show()
    this.noteService.update(this.compositionId,{
      notes:this.data
    }).subscribe((res:any)=>{
      this.loading=false
      this.spinnerService.hide()
        this.toastrService.success(res.message)
        this.router.navigate(['/professor-module/note-index'])
    },
    (err:any)=>{
      this.loading=false
      this.spinnerService.hide()

      console.log(err)
        AppErrorShow.showError("Gestion des notes",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.sacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des notes",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des notes",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  correctValue(ev:any,i:any){
    console.log(ev.target.value)
    if (ev.target.value<0) {
      this.data[i].value=0
    }
    if (ev.target.value>20) {
      this.data[i].value=20
    }
  }

  prepareTask(value:any){
    console.log(value)
    this.compositionData=value
    this.modalService.dismissAll()
  }
}


